export const arrayShallowEquals = (array1, array2) => {
    if (array1.length !== array2.length) return false
    return array1.every((e, i) => e === array2[i])
}

export const objectShallowEquals = (object1, object2) =>
    arrayShallowEquals(Object.keys(object1), Object.keys(object2)) &&
    arrayShallowEquals(Object.values(object1), Object.values(object2))

export const compose =
    (...functions) =>
    x =>
        functions.reduceRight((y, fn) => fn(y), x)

export const not = x => !x

export const flip = f => x => y => f(y)(x)

// List
export const range = length => Array.from({ length }, (_, i) => i)

export const partition = predicate => array => {
    const pass = []
    const fail = []
    array.forEach((e, i, arr) => (predicate(e, i, arr) ? pass : fail).push(e))
    return [pass, fail]
}

export const updateWhere = predicate => newEl => array =>
    array.map((e, i, a) => (predicate(e, i, a) ? newEl : e))
     
export const unique = array => [...new Set(array)]

export const includes = el => array => array.includes(el)

export const isIn = flip(includes)
export const isNotIn = array => compose(not, isIn(array))

export const head = array => array[0]
export const last = array => array[array.length - 1]
export const tail = (x, ...xs) => xs
export const init = array => array.slice(0, -1)

export const sort = (array, compareFnc) => [...array].sort(compareFnc)

export const zip = array1 => array2 =>
    range(Math.min(array1.length, array2.length)).map(i => [
        array1[i],
        array2[i],
    ])
// Object
export const objectMap = fn => obj =>
    Object.fromEntries(
        Object.entries(obj).map(([key, value]) => [key, fn(value, key)]),
    )

export const prop = key => obj => obj[key]

export const propEq = key => value => obj => obj[key] === value
export const propNotEq = key => value => obj => obj[key] !== value
export const propIn = key => array => compose(isIn(array), prop(key))

export const getId = prop("id")
export const idEq = propEq("id")
export const idNotEq = propNotEq("id")
export const idIn = ids => compose(isIn(ids), getId)
export const idNotIn = ids => compose(not, idIn(ids))
